import React from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "react-bootstrap";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import TextInput from "../../../components/forms/TextInput";
import SelectInput from "../../../components/forms/SelectInput";
import { validationMode } from "../../../config/helpers";

interface SectionComplementairesProps {
  isSecteurActivitesLoading: boolean;
  secteurActivites: any;
  watchedMessage: string | undefined;
  watchedAcceptationCGU: boolean;
  handleOpenModalConvention: (e: React.MouseEvent) => void;
  handleCheckboxClick: (e: React.MouseEvent<HTMLInputElement>) => void;
  onRetour: () => void;
  sirenApiError: string | null;
}

const SectionComplementaires: React.FC<SectionComplementairesProps> = ({
  isSecteurActivitesLoading,
  secteurActivites,
  watchedMessage,
  watchedAcceptationCGU,
  handleOpenModalConvention,
  handleCheckboxClick,
  onRetour,
  sirenApiError,
}) => {
  const { register, formState } = useFormContext();

  return (
    <CpntFormSection pSectionLabel="INFORMATIONS COMPLÉMENTAIRES">
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
        <TextInput
          label="GLN éditeur"
          type="number"
          formName="GLNEditeur"
          validationStyle={validationMode.classic}
          placeholder="Numéro à 13 chiffres"
          maxLength={13}
        />
        <TextInput
          label="Marque principale"
          formName="MarquePrincipale"
          validationStyle={validationMode.classic}
          placeholder="Valeur"
        />
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <SelectInput
          label="Secteur d'activité"
          formName="IdSecteurActivite"
          ismandatory={true}
          optionEmpty="Sélectionnez un secteur d'activité"
          validationStyle={validationMode.classic}
          options={
            isSecteurActivitesLoading 
              ? []
              : secteurActivites?.SecteurActivites?.map((s: any) => ({
                  Id: s.Id,
                  Libelle: s.Libelle,
                })) || []
          }
        />
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <div className="mb-3">
          <label className="d-block mb-2">Indicatif (Segment) ISBN</label>
          <div className="row g-2">
            <div className="col-4">
              <SelectInput
                label=""
                formName="IndicatifISBN"
                validationStyle={validationMode.classic}
                options={[
                  { Id: "978", Libelle: "978" },
                  { Id: "979", Libelle: "979" },
                ]}
              />
            </div>
            <div className="col-4">
              <TextInput
                label=""
                type="number"
                formName="ISBN1"
                validationStyle={validationMode.classic}
                placeholder="Valeur"
                maxLength={10}
              />
            </div>
            <div className="col-4">
              <TextInput
                label=""
                type="number"
                formName="ISBN2"
                validationStyle={validationMode.classic}
                placeholder="Valeur"
                maxLength={10}
              />
            </div>
          </div>
        </div>
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <TextInput
          label="Référence ISBN13 / EAN complet"
          formName="ISBN13EANComplet"
          validationStyle={validationMode.classic}
          placeholder="Merci de renseigner l'ISBN13/EAN d'un de vos ouvrages"
          maxLength={40}
        />
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <TextInput
          label="GLN distributeur"
          type="number"
          formName="GLNDiffuseur"
          validationStyle={validationMode.classic}
          placeholder="Numéro à 13 chiffres"
          maxLength={13}
        />
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <div className="mb-3">
          <label className="d-block mb-2" style={{ fontStyle: "italic" }}>
            Message (si vous souhaitez apporter des précisions à votre demande)
          </label>
          <textarea
            {...register("Message")}
            className="form-control"
            rows={6}
            maxLength={600}
          />
          <div className="text-end mt-1" style={{ fontSize: "0.9em", color: "#6c757d" }}>
            Nb car(s) restant(s): {600 - (watchedMessage?.length || 0)}
          </div>
          {formState.errors.Message && (
            <div className="text-danger mt-1">
              {formState.errors.Message.message as string}
            </div>
          )}
        </div>
      </CpntFormSectionContainer>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
       <div className="mb-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              {...register("AcceptationCGU")}
              id="accepte-convention"
              onClick={handleCheckboxClick}
              style={{ cursor: "pointer" }}
            />
            <label className="form-check-label" htmlFor="accepte-convention" style={{ cursor: "pointer" }}>
              J&apos;accepte{" "}
              <a href="#" onClick={handleOpenModalConvention} style={{ textDecoration: "underline" }}>
                les conditions générales de vente et d&apos;utilisation
              </a>
              {" "}<span className="text-danger">*</span>
            </label>
          </div>
          {formState.errors.AcceptationCGU && (
            <div className="text-danger mt-1">
              {formState.errors.AcceptationCGU.message as string}
            </div>
          )}
        </div>
      </CpntFormSectionContainer>
      <CpntFormSectionNavigation>
        <div className="d-flex gap-3 col-12">
          <Button
            type="button"
            className="btn-primary"
            style={{ flex: 1 }}
            onClick={onRetour}
          >
            RETOUR
          </Button>
          <Button
            type="submit"
            className="btn-secondary"
            style={{ flex: 1 }}
            disabled={!formState.isValid || !watchedAcceptationCGU || !!sirenApiError}
          >
            VALIDER
          </Button>
        </div>
      </CpntFormSectionNavigation>
    </CpntFormSection>
  );
};

export default SectionComplementaires;
